document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-miuvi-menu-toggle]');
  var drawer = document.querySelector('[data-miuvi-menu-drawer]');
  var overlay = document.querySelector('[data-miuvi-drawer-overlay]');
  var closeBtn = document.querySelector('[data-miuvi-menu-close]');
  if (!toggle || !drawer) return;

  var lastFocused = null;

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    if (overlay) {
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    }
    document.documentElement.classList.add('miuvi-scroll-lock');
    document.body.classList.add('miuvi-scroll-lock');
    if (closeBtn) { closeBtn.focus(); }
    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    if (overlay) {
      overlay.classList.remove('is-open');
      setTimeout(function () { overlay.hidden = true; }, 250);
    }
    document.documentElement.classList.remove('miuvi-scroll-lock');
    document.body.classList.remove('miuvi-scroll-lock');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused) { lastFocused.focus(); }
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      closeDrawer();
    }
  }

  toggle.addEventListener('click', function () {
    if (drawer.classList.contains('is-open')) { closeDrawer(); } else { openDrawer(); }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  drawer.querySelectorAll('[data-miuvi-drawer-link]').forEach(function (link) {
    link.addEventListener('click', function () {
      closeDrawer();
    });
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 990 && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
});
